module.exports = __webpack_public_path__ + "img/blended.4f06a6bc.jpg";